import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M692.080941,851.621647 L1035.08329,1194.624 C1088.39153,1247.93224 1117.75624,1318.85929 1117.75624,1394.19106 C1117.75624,1469.63576 1088.39153,1540.56282 1035.08329,1593.87106 L1018.59388,1610.36047 L276.231529,868.111059 L292.720941,851.621647 C399.450353,744.779294 585.464471,744.779294 692.080941,851.621647 Z M1032.25976,464.233412 L1422.69741,854.671059 L1136.50447,1140.864 C1129.16329,1132.28047 1123.06447,1122.79341 1114.93271,1114.77459 L771.930353,771.772235 C763.911529,763.640471 754.424471,757.880471 745.840941,750.652235 L1032.25976,464.233412 Z M1135.03624,159.744 L1727.18682,751.781647 L1643.27153,835.696941 C1621.248,857.720471 1585.44565,857.720471 1563.42212,835.696941 L1542.97976,815.254588 C1542.75388,815.028706 1542.75388,814.802824 1542.528,814.576941 C1542.30212,814.464 1542.07624,814.464 1541.96329,814.238118 L1072.80565,345.080471 C1072.57976,344.854588 1072.46682,344.515765 1072.24094,344.289882 C1072.01506,344.064 1071.67624,343.951059 1071.45035,343.838118 L1051.12094,323.508706 C1029.09741,301.485176 1029.09741,265.569882 1051.12094,243.546353 L1135.03624,159.744 Z M1135.03624,0.0451764706 L971.271529,163.696941 C911.977412,222.991059 908.928,314.473412 956.250353,380.544 L658.876235,677.918118 C654.810353,681.871059 652.438588,686.727529 649.840941,691.471059 C505.276235,631.386353 326.942118,657.814588 212.871529,771.772235 L116.532706,868.111059 L527.638588,1279.21694 L16.5797647,1790.27576 C-5.55670588,1812.29929 -5.55670588,1848.10165 16.5797647,1870.12518 C27.5350588,1881.19341 41.9915294,1886.72753 56.448,1886.72753 C70.9044706,1886.72753 85.3609412,1881.19341 96.4291765,1870.12518 L607.488,1359.06635 L1018.59388,1770.05929 L1114.93271,1673.72047 C1189.58682,1599.17929 1230.69741,1499.904 1230.69741,1394.19106 C1230.69741,1339.07576 1218.95153,1285.88047 1197.60565,1236.864 C1200.20329,1234.944 1203.25271,1233.81459 1205.62447,1231.44282 L1506.38682,930.680471 C1535.75153,951.574588 1568.84329,965.127529 1603.29035,965.127529 C1646.65976,965.127529 1690.14212,948.525176 1723.12094,915.546353 L1886.88565,751.781647 L1135.03624,0.0451764706 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconPinLine = /*#__PURE__*/function (_Component) {
  _inherits(IconPinLine, _Component);

  var _super = _createSuper(IconPinLine);

  function IconPinLine() {
    _classCallCheck(this, IconPinLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconPinLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconPin",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconPinLine.displayName = "IconPinLine";
  return IconPinLine;
}(Component);

IconPinLine.glyphName = 'pin';
IconPinLine.variant = 'Line';
IconPinLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconPinLine;
export { IconPinLine };